import React from "react";
import { Route } from "react-router-dom";
import Payment from "../../../containers/modules/purchasing/payment";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function PaymentRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="payment"
      index
      element={
        <AccessControl
          name={"Payment List"}
          auth={authUser}
          component={() => <Payment />}
        />
      }
    ></Route>
  );
}
